module.exports = __webpack_public_path__ + "img/record-btn.a4305756.svg";